// js
import React from 'react';
import PropTypes from 'prop-types';
import QuestionAccordion from '../common/QuestionAccordion';
import SecurityCorrelationsQuestion from './SecurityCorrelationsQuestion';


function SecurityCorrelationsCategory({category, onAnswer, onToggle, active}) {

  return (
    <QuestionAccordion
      open={active}
      title={category.title}
      onToggle={() => onToggle(category.id)}
      itemsCompleteCount={category.answeredCount}
      itemsTotalCount={category.correlations.length}
    >
      <table className='table'>
        <tbody>
          {category.correlations.map((correlation) => (
            <tr key={correlation.id}>
              <td>
                <SecurityCorrelationsQuestion
                  onAnswer={onAnswer(correlation)}
                  correlation={correlation}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </QuestionAccordion>
  );
}

SecurityCorrelationsCategory.propTypes = {
  category: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
  onAnswer: PropTypes.func.isRequired,
  active: PropTypes.bool
};

export default SecurityCorrelationsCategory;



// WEBPACK FOOTER //
// ./src/components/correlations/SecurityCorrelationsCategory.js